/**
 * Grouped date + time inputs matching the create-session design:
 * "Start Date / Time" with Date | Time side by side.
 */

interface DateTimeFieldProps {
  label: string;
  date: string;
  time: string;
  onDateChange: (value: string) => void;
  onTimeChange: (value: string) => void;
}

export function DateTimeField({
  label,
  date,
  time,
  onDateChange,
  onTimeChange,
}: DateTimeFieldProps) {
  return (
    <div className="mb-0">
      <label className="form-label">{label}</label>
      <div className="row g-2">
        <div className="col">
          <label className="form-label small text-muted mb-1">Date</label>
          <input
            type="date"
            value={date}
            onChange={(e) => onDateChange(e.target.value)}
            className="form-control"
          />
        </div>
        <div className="col">
          <label className="form-label small text-muted mb-1">Time</label>
          <input
            type="time"
            value={time}
            onChange={(e) => onTimeChange(e.target.value)}
            className="form-control"
          />
        </div>
      </div>
    </div>
  );
}
